import { createRouter } from '@tanstack/react-router';
import { routeTree } from './routeTree.gen';

/**
 * Router único do TanStack Router (file-based). As rotas vivem em src/routes/ e o
 * routeTree.gen.ts é gerado pelo plugin do Vite (TanStackRouterVite) — não editar à mão.
 */
export const router = createRouter({
  routeTree,
  defaultPreload: 'intent',
});

declare module '@tanstack/react-router' {
  interface Register {
    router: typeof router;
  }
}
